module.exports = __webpack_public_path__ + "static/media/16.Jigsaw.8a40dc32.jpg";